"use client";

import dynamic from "next/dynamic";

import type { CreativeCalculatorProps } from "./CreativeCalculator";

const CreativeCalculator = dynamic(() => import("./CreativeCalculator").then(mod => mod.CreativeCalculator), {
  ssr: false,
});

export function CreativeCalculatorWrapper(props: CreativeCalculatorProps) {
  return <CreativeCalculator {...props} />;
}
